import { StepShell } from '../components/layout';
import { LikertItem } from '../components/selection';
import { Note } from '../components/inputs';

/**
 * Deliberately framed as preferences rather than a test. No score is shown,
 * no "correct" answer exists, and the underlying dimensions are never named.
 */
export default function WorkStyleStep({ data, update, notes = {}, config }) {
  const answers = data.answers || {};
  const { statements, scale } = config.workStyle;
  const answered = statements.filter((s) => answers[s.key]).length;

  const setAnswer = (key, value) => {
    update({ answers: { ...answers, [key]: value } });
  };

  return (
    <StepShell
      eyebrow="Step 7 of 18"
      title="How you like to work"
      lede="There is no right answer to any of these, and nobody is scored on them. Just go with your first instinct — that is usually the honest one."
      why="Teams work better when people are placed alongside colleagues whose habits complement theirs. This tells us how you prefer to operate, not how good you are."
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <span className="ob-group-label" style={{ marginBottom: 0 }}>
          {statements.length} quick statements
        </span>
        <span className="ob-selected-count" data-met={answered === statements.length}>
          {answered} of {statements.length}
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {statements.map((statement) => (
          <LikertItem
            key={statement.key}
            statement={statement}
            scale={scale}
            value={answers[statement.key]}
            onChange={(value) => setAnswer(statement.key, value)}
          />
        ))}
      </div>

      {notes.answers && <Note>{notes.answers}</Note>}
    </StepShell>
  );
}
